import React from 'react'
import { Resource } from 'react-admin';

import BusinessUnit from  './business_unit'
import SalesTerritory from './sales_territory'
import ChainStatus from './chain_status'
import ChainRep from './chain_rep'


const Resources = [
    <Resource name='kraftheinz_chain_to_chain_mapping' />,


    <Resource {...BusinessUnit}/>,


    <Resource {...SalesTerritory}/>,
    <Resource name='kraftheinz_sales_territory_chain_mapping' />,
    <Resource name='kraftheinz_sales_territory_warehouse_mapping' />,

    <Resource {...ChainStatus}/>,
    <Resource name='kraftheinz_chain_status_chain_mapping' />,
    <Resource name='kraftheinz_chain_status_warehouse_mapping' />,

    <Resource {...ChainRep}/>,
    <Resource name='kraftheinz_chain_rep_chain_mapping' />,
    <Resource name='kraftheinz_chain_rep_warehouse_mapping' />,
]

export default Resources